import {
  isRouteErrorResponse,
  useNavigate,
  useRouteError,
} from "react-router-dom";
import * as Sentry from "@sentry/react";
import { useTranslation } from "react-i18next";

import svg404 from "@/resources/svg/404.svg";
import svg500 from "@/resources/svg/500.svg";

import { Button } from "@industriousoffice/react-components";

import { Page } from "../Page/Page";
import Layout from "../Layout";

export function ErrorBoundary() {
  const error = useRouteError();
  const { t } = useTranslation();
  const navigate = useNavigate();

  if (import.meta.env.DEV) {
    // eslint-disable-next-line no-console
    console.error(error);
  }

  Sentry.captureException(error);

  const is404 = isRouteErrorResponse(error) && error.status === 404;
  const title = is404 ? t("Page Not Found") : t("Something Went Wrong");
  const description = is404
    ? t(`Please try our home page.`)
    : t(`Please refresh the page and try again.`);

  return (
    <Page>
      <div className="min-h-page mt-0 flex items-stretch content-stretch flex-col">
        <Layout className="pt-12 px-0! h-full mt-0! lg:grow lg:shrink-0 flex flex-wrap items-center">
          <div className="w-full grow shrin-0 lg:w-1/2 text-center flex justify-center">
            <img
              src={is404 ? svg404 : svg500}
              alt="404"
              className="w-[600px] max-w-full"
            />
          </div>
          <div className="w-full lg:w-1/2 p-12 flex flex-col items-center content-center text-center">
            <h1 className="text-4xl 2xl:text-6xl font-medium mb-4 2xl:mb-12 font-tiempos">
              {title}
            </h1>
            <p className="text-sm 2xl:text-xl mb-8">{description}</p>
            {is404 ? (
              <Button
                onClick={() => {
                  navigate("/");
                }}
              >
                {t("Home")}
              </Button>
            ) : (
              <Button onClick={() => window.location.reload()}>
                {t("Refresh")}
              </Button>
            )}
          </div>
        </Layout>
      </div>
    </Page>
  );
}
